import { DocumentReference } from "firebase/firestore";

export type Content = {
  id: string;
  data: {
    name: string;
    description?: string;
    owner: DocumentReference;
    price?: number;
    public: boolean;
    tags: DocumentReference[];
    trusted: boolean;
    copyOf?: DocumentReference;
    copyDate?: Date;
    templatesInfo: TemplateInfo[];
  };
};

export type Palette = {
  title: string;
  buttons: PaletteButton[];
};

export type PaletteButton = {
  title: string;
  speech: string;
  color: Color;
  emotion: Emotion;
  goal: string;
  subgoal: string;
  proficiency: string;
};

export type TemplateInfo = {
  id: string;
  title: string;
  description?: string;
  copyOf?: DocumentReference;
  copyDate?: Date;
};

export type Template = {
  id?: string;
  title: string;
  description?: string;
  contentID?: string;
  contentName?: string;
  buttons: { [key: string]: RobotControlButton };
  hierarchy: { root: string[]; [key: string]: string[] };
  copyOf?: DocumentReference;
  copyDate?: Date;
  sourceContentId?: string;
};

export const blankTemplate: Template = {
  title: "Blank Template",
  buttons: {
    blank: {
      type: "Message",
      labelColor: "Light Blue",
      details: {
        title: "Select a button to see its info",
        speech: "Select a button to see its info",
        color: "Light Blue",
        emotion: "Neutral",
      },
    },
  },
  hierarchy: { root: ["blank"] },
};

export type TemplateDetails = {
  buttons: { [key: string]: RobotControlButton };
  hierarchy: { root: string[]; [key: string]: string[] };
};

export type TemplatesObject = { [key: string]: Template };
export type OrderedTemplatesObject = {
  templates: TemplatesObject;
  order: string[];
};

export type RobotControlButton =
  | {
      type: "Message";
      labelColor: Color;
      details: Message;
    }
  | {
      type: "Log";
      labelColor: Color;
      details: LoggedEvent;
    };

export type RobotControlButtonAction =
  | { type: "CLICK" }
  | { type: "SELECT" }
  | { type: "ADD TO SELECTION" }
  | { type: "REMOVE FROM SELECTION" }
  | { type: "DELETE" }
  | { type: "SAVE"; newButton: RobotControlButton }
  | { type: "MOVE"; direction: "FORWARD" | "BACK" };

export const blankMessageButton: RobotControlButton = {
  type: "Message",
  labelColor: "Light Blue",
  details: {
    title: "Select a button to see its info",
    speech: "Select a button to see its info",
    color: "Light Blue",
    emotion: "Neutral",
  },
};

export type Message = {
  title: string;
  speech: string;
  color: Color;
  emotion: Emotion;
  metadata?: MetaData;
};

export const connectionMessage: Message = {
  title: "Connecting",
  speech: "Connecting",
  color: "Light Blue",
  emotion: "Neutral",
};

export type LoggedEvent = {
  title: string;
  details?: string;
  metadata?: MetaData;
};

export type MetaData = {
  [key: string]: string | number;
};

export type MetaDataDefinition = {
  [key: string]:
    | {
        type: "select";
        options: string[];
      }
    | {
        type: "number";
        min: number;
        max: number;
      }
    | {
        type: "string";
      };
};

export type Emotion =
  | "Neutral"
  | "Surprised"
  | "Happy"
  | "Sad"
  | "Concerned"
  | "Sleepy";

export type Color =
  | "Light Blue"
  | "Blue"
  | "Green"
  | "Red"
  | "Purple"
  | "Pink"
  | "Yellow"
  | "Orange"
  | "Grey"
  | "Black"
  | "White";
